/**
 * A type guard is a function used in TypeScript to refine the type of a value at runtime.
 * It ensures that a given value matches a specific type, improving type safety and clarity.
 */

import { Organisation } from './organisation';

export function isOrganisation(
  response: Organisation | null,
): response is Organisation {
  if (!response) {
    return false;
  }

  return (response as Organisation).id !== undefined;
}
